import Swal from 'sweetalert2';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Directorio = {
    agregarDirectorio: async (data) => {
        let url = url_json + "/directorio"
        let body = {
            correo: data.correo,
            nombre: data.nombre,
            numero: data.numero,
            posicion: data.posicion,
            puesto: data.puesto
        };
        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Persona agregada correctamente' ,
              'success'
            ).then(() => {
              window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar la persona, codigo: ' + res.message ,
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerDirectorios: async () => {
        let url = url_json + "/directorio"
        let request = {
            method:'GET',
            headers: {
                "Content-type":"application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerUnDirectorio: async id => {
        let url = url_json + "/directorio/" + id
        let request = {
            method:'GET',
            headers: {
                "Content-type":"application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarDirectorio: async (data, id) => {
        let url = url_json + "/directorio/" + id;
        let body = {
            correo: data.correo,
            nombre: data.nombre,
            numero: data.numero,
            posicion: data.posicion,
            puesto: data.puesto
        };
        let request = {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Modificación exitosa!',
                'Persona modificada correctamente' ,
                'success'
            ).then(() => {
                window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo modificar la persona' ,
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data };
    },
    eliminarDirectorio: async id => {
        let url = url_json + "/directorio/delete/" + id;
        let request = {
            method: 'PATCH',
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Eliminación exitosa!',
                'Persona eliminada correctamente' ,
                'success'
            ).then(() => {
                window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo eliminar la persona' ,
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data };
    }
}

export default Directorio;
